import { connect } from 'react-redux';
import { isRoleLoading, selectPermission } from '@selectors/authentication';
import { PrivateRoute } from './PrivateRoute';

const mapStateToProps = (state) => ({
  role: selectPermission(state),
  isRoleLoading: isRoleLoading(state),
});

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./components/organisms/PrivateRoute/index.js